// src/components/ImportSageMakerButton.js

import React, { useState } from 'react';
import { authFetch } from './authFetch';
import { Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
  importSageMakerModelsRequest,
  importSageMakerModelsSuccess,
  importSageMakerModelsFailure,
} from '../redux/actions/cloudModels';

function ImportSageMakerButton() {
  const dispatch = useDispatch();
  const [isImporting, setIsImporting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleImport = async () => {
    setIsImporting(true);
    dispatch(importSageMakerModelsRequest());
    try {
      const response = await authFetch('/.netlify/functions/fetchSageMakerModels');
      const result = await response.json();

      if (result.success) {
        // Append source information
        const modelsWithSource = result.data.map(model => ({
          ...model,
          source: 'SageMaker',
        }));
        dispatch(importSageMakerModelsSuccess(modelsWithSource));
        setSnackbar({ open: true, message: 'Models imported successfully from SageMaker.', severity: 'success' });
      } else {
        console.error('Error importing models from SageMaker:', result.error);
        dispatch(importSageMakerModelsFailure(result.error));
        setSnackbar({ open: true, message: 'Failed to import models from SageMaker.', severity: 'error' });
      }
    } catch (error) {
      console.error('Error importing models from SageMaker:', error);
      dispatch(importSageMakerModelsFailure(error.message));
      setSnackbar({ open: true, message: 'Failed to import models from SageMaker.', severity: 'error' });
    }
    setIsImporting(false);
  };
  return (
    <>
      <Button
        variant="text"
        color="inherit"
        onClick={handleImport}
        disabled={isImporting}
        startIcon={isImporting && <CircularProgress size={20} />}
        style={{ textTransform: 'none' }}
      >
        {isImporting ? 'Importing...' : 'Import from SageMaker'}
      </Button>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ImportSageMakerButton;